import { __makeTemplateObject } from "tslib";
import styled from '@marvelapp/styled';
import Box from '../Box';
export var BadgeElement = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n"], ["\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n"])));
var templateObject_1;
